// purpose: コンボ段階テーブルの純関数（閾値の単一正本）。HUD（app）と体感層（runtime）が同じ表を読む。

export interface ComboPhase {
  readonly name: string;
  readonly className: string;
}

interface ComboTier extends ComboPhase {
  readonly minChain: number;
  readonly announced: boolean;
}

const CHAIN_START = 2;
const RUSH_START = 5;
const STORM_START = 10;
const OVERDRIVE_START = 20;

const TIERS: readonly ComboTier[] = [
  { minChain: 1, name: 'CHAIN', className: 'combo-start', announced: false },
  { minChain: CHAIN_START, name: 'CHAIN', className: 'combo-chain', announced: false },
  { minChain: RUSH_START, name: 'RUSH', className: 'combo-rush', announced: true },
  { minChain: STORM_START, name: 'STORM', className: 'combo-storm', announced: true },
  { minChain: OVERDRIVE_START, name: 'OVERDRIVE', className: 'combo-overdrive', announced: true },
];

export function comboTierIndex(chain: number): number {
  for (let i = TIERS.length - 1; i > 0; i -= 1) {
    if (chain >= TIERS[i].minChain) return i;
  }
  return 0;
}

export function comboPhase(chain: number): ComboPhase {
  return TIERS[comboTierIndex(chain)];
}

export function comboAnnouncement(chain: number): ComboPhase | null {
  const tier = TIERS[comboTierIndex(chain)];
  return tier.announced ? tier : null;
}
